import { Plugin } from "prosemirror-state";

import { nodeAttrsToStatus } from "~/actionItems/utils";

import { Extension } from "../extension";
import { isNodeEmpty } from "../utils";

const blocksToFillWithCreator = ["embed", "key_result", "image_strip"];

export default class BlockCreator extends Extension {
	get name() {
		return "blockCreator";
	}

	get plugins() {
		const { userId } = this.options;

		return [
			new Plugin({
				appendTransaction(transactions, oldState, newState) {
					const tr = newState.tr;
					newState.doc.descendants((node, pos) => {
						const { creator, assignees } = node.attrs;
						let newAttrs = {};
						if (blocksToFillWithCreator.includes(node.type.name) || !isNodeEmpty(node)) {
							if (typeof creator != "undefined") {
								if (creator == null) {
									let assignees = node.attrs.assignees;
									if (!assignees || assignees.length === 0) {
										assignees = [{ id: userId, status: nodeAttrsToStatus(node.attrs) }];
									}
									newAttrs = {
										...newAttrs,
										creator: userId,
										assignees,
									};
								}
							}
						} else {
							if (creator) {
								newAttrs = { ...newAttrs, creator: null };
							}
							if (assignees?.length) {
								newAttrs = { ...newAttrs, assignees: [] };
							}
						}
						if (Object.keys(newAttrs).length) {
							tr.setNodeMarkup(pos, undefined, { ...node.attrs, ...newAttrs });
						}
						return false;
					});

					if (tr.docChanged) return tr.setMeta("inputRulesIgnore", true);

					return undefined;
				},
			}),
		];
	}
}
